/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownCountryCallingCode } from '../models/db_DropdownCountryCallingCode';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CountryCallingCodes {
    /**
     * Get a list of country calling codes
     * @returns db_DropdownCountryCallingCode OK
     * @throws ApiError
     */
    public static listCountryCallingCodes(): CancelablePromise<Array<db_DropdownCountryCallingCode>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/country-calling-codes',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
